export function caseInsensitiveMatch(searchTerm, text) {
  if (!searchTerm) return true;
  if (!text) return false;

  return text.toLowerCase().includes(searchTerm.toLowerCase());
}
